// Unified 3D Gallery Integration - Works on both mobile and desktop
(function() {
  'use strict';
  
  let isInitialized = false;
  let currentView = 'gallery'; // 'gallery' or '3d'
  
  // Function to ensure Plattar takes full container dimensions and reinitializes properly
  function fixShopifyBlockWidth() {
    const unified3dViewer = document.getElementById('unified-3d-viewer');
    if (!unified3dViewer || !unified3dViewer.classList.contains('plattar-loaded')) {
      return; // Only fix if Plattar is actually loaded
    }
    
    console.log('Fixing Plattar container dimensions...');
    
    // Get container dimensions first
    const containerRect = unified3dViewer.getBoundingClientRect();
    console.log('Container dimensions:', containerRect.width, 'x', containerRect.height);
    
    if (containerRect.width === 0 || containerRect.height === 0) {
      console.warn('Container has no dimensions, skipping resize');
      return;
    }
    
    // Fix all Plattar-related elements to take full size
    const elementsToResize = unified3dViewer.querySelectorAll(`
      .shopify-app-block,
      [id*="shopify-block"],
      .plattar-embed-wrapper,
      plattar-viewer,
      plattar-viewer iframe
    `);
    
    console.log(`Found ${elementsToResize.length} Plattar elements to resize`);
    
    elementsToResize.forEach((element, index) => {
      console.log(`Resizing element ${index + 1}: ${element.tagName}`);
      element.style.width = containerRect.width + 'px';
      element.style.height = containerRect.height + 'px';
      element.style.minWidth = containerRect.width + 'px';
      element.style.minHeight = containerRect.height + 'px';
      element.style.maxWidth = 'none';
      element.style.maxHeight = 'none';
    });
    
    // Try to style iframe content (may not work due to cross-origin)
    tryToStyleIframe();
    
    // Trigger multiple resize events with delays to ensure Plattar catches them
    setTimeout(() => {
      console.log('Triggering resize event 1');
      window.dispatchEvent(new Event('resize'));
    }, 100);
    setTimeout(() => {
      console.log('Triggering resize event 2');
      window.dispatchEvent(new Event('resize'));
    }, 300);
    setTimeout(() => {
      console.log('Triggering resize event 3');
      window.dispatchEvent(new Event('resize'));
    }, 500);
    
    // Try to reinitialize Plattar if available
    reinitializePlattar();
  }

  // Function to reinitialize Plattar viewer
  function reinitializePlattar() {
    console.log('Attempting to reinitialize Plattar...');
    
    // Try various Plattar reinitialization methods
    if (window.Plattar && window.Plattar.Scene) {
      console.log('Plattar Scene API available, attempting refresh');
      try {
        // Force refresh all scenes
        window.Plattar.Scene.refresh();
      } catch (e) {
        console.log('Plattar Scene refresh failed:', e);
      }
    }
    
    // Try to find and reinitialize plattar-viewer elements
    const plattarViewers = document.querySelectorAll('plattar-viewer');
    plattarViewers.forEach((viewer, index) => {
      console.log(`Reinitializing Plattar viewer ${index + 1}`);
      
      // Try to trigger viewer refresh
      if (viewer.refresh && typeof viewer.refresh === 'function') {
        viewer.refresh();
      }
      
      // Try to reset viewer
      if (viewer.reset && typeof viewer.reset === 'function') {
        viewer.reset();
      }
      
      // Force viewer to recalculate dimensions
      viewer.style.display = 'none';
      setTimeout(() => {
        viewer.style.display = 'block';
        // Trigger resize on the viewer
        if (viewer.resize && typeof viewer.resize === 'function') {
          viewer.resize();
        }
      }, 50);
    });
    
    // Dispatch custom events that Plattar might listen to
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('plattar-refresh'));
      window.dispatchEvent(new CustomEvent('plattar-resize'));
    }, 200);
  }
  
  // Attempt to style iframe content
  function tryToStyleIframe() {
    const iframes = document.querySelectorAll('plattar-viewer iframe');
    iframes.forEach(iframe => {
      try {
        // This will only work if same-origin
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        if (iframeDoc) {
          // Inject style into iframe
          const style = iframeDoc.createElement('style');
          style.textContent = `
            .isDesktop, body {
              background-color: rgb(224, 224, 224) !important;
            }
          `;
          iframeDoc.head.appendChild(style);
        }
      } catch (e) {
        // Cross-origin, can't access - try postMessage instead
        console.log('Cannot directly access iframe, trying postMessage');
        iframe.contentWindow.postMessage({
          type: 'updateBackground',
          color: 'rgb(224, 224, 224)'
        }, '*');
      }
    });
  }
  
  // Store element references globally within closure
  let view3dBtn, unified3dViewer, glideElement, viewAtHomeBtn;
  
  // Function to remove loading overlays - more targeted approach
  function removeLoadingOverlays() {
    // Only remove elements with class plattar-loading
    const loadingOverlays = document.querySelectorAll('.plattar-loading');
    loadingOverlays.forEach(overlay => {
      overlay.style.display = 'none';
    });
    
    // Hide loading spinner
    const loadingSpinners = document.querySelectorAll('.plattar-loading-spinner');
    loadingSpinners.forEach(spinner => {
      spinner.style.display = 'none';
    });
  }
  
  // Initialize unified 3D gallery controls (works on both mobile and desktop)
  function initUnified3DGallery() {
    console.log('Attempting to initialize unified 3D gallery...');
    
    if (isInitialized) {
      console.log('Already initialized, skipping');
      return;
    }
    
    // Get element references
    view3dBtn = document.getElementById('view-3d-btn');
    unified3dViewer = document.getElementById('unified-3d-viewer');
    glideElement = document.querySelector('.product-glide');
    viewAtHomeBtn = document.getElementById('view-at-home-btn');
    
    console.log('Elements found:', {
      view3dBtn: !!view3dBtn,
      unified3dViewer: !!unified3dViewer,
      glideElement: !!glideElement,
      viewAtHomeBtn: !!viewAtHomeBtn
    });
    
    if (!view3dBtn) {
      console.log('View 3D button not found - selector: #view-3d-btn');
      return;
    }
    
    if (!unified3dViewer) {
      console.log('3D viewer not found - selector: #unified-3d-viewer');
      return;
    }
    
    isInitialized = true;
    console.log('✅ Unified 3D gallery initialized successfully!');

    // Set up MutationObserver to adjust container when Plattar loads
    if (unified3dViewer) {
      const observer = new MutationObserver((mutations) => {
        let plattarAdded = false;
        let plattarIframeAdded = false;
        
        mutations.forEach(mutation => {
          // Check if Plattar added new nodes
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) {
                if (node.id === 'plattar-3d-block-container' ||
                    node.className === 'plattar-embed-wrapper' ||
                    node.tagName === 'PLATTAR-VIEWER') {
                  plattarAdded = true;
                  console.log('Plattar element added:', node.tagName, node.className);
                }
                
                // Check for iframe specifically
                if (node.tagName === 'IFRAME' || node.querySelector('iframe')) {
                  plattarIframeAdded = true;
                  console.log('Plattar iframe detected');
                }
              }
            });
          }
        });
        
        if (plattarAdded) {
          console.log('Plattar elements detected, initializing...');
          setTimeout(() => {
            removeLoadingOverlays();
            fixShopifyBlockWidth();
          }, 100);
          
          // Additional initialization when iframe is ready
          if (plattarIframeAdded) {
            setTimeout(() => {
              console.log('Plattar iframe ready, final initialization...');
              fixShopifyBlockWidth();
            }, 500);
          }
        }
      });
      
      // Observe with comprehensive options
      observer.observe(unified3dViewer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'style']
      });
    }
    
    // Function to show gallery
    function showGallery() {
      currentView = 'gallery';
      console.log('Showing gallery view');
      
      if (view3dBtn) {
        view3dBtn.classList.remove('active');
        view3dBtn.innerHTML = '<span>View 3D</span>';
      }
      
      // Hide 3D viewer
      if (unified3dViewer) {
        unified3dViewer.classList.remove('active');
      }
      
      // Show gallery
      if (glideElement) {
        glideElement.classList.remove('hidden-for-3d');
      }
      
      // Re-initialize Glide if needed
      if (window.productGlide) {
        setTimeout(() => {
          window.productGlide.update();
          // Update arrow visibility when switching back to gallery
          if (typeof updateArrowVisibility === 'function') {
            updateArrowVisibility();
          }
        }, 100);
      }
    }
    
    // Function to show 3D with lazy loading
    function show3D() {
      currentView = '3d';
      console.log('Showing 3D view with lazy loading');
      
      if (view3dBtn) {
        view3dBtn.classList.add('active');
        view3dBtn.innerHTML = '<span>View Gallery</span>';
      }
      
      // Hide gallery
      if (glideElement) {
        glideElement.classList.add('hidden-for-3d');
      }
      
      // Show 3D viewer
      if (unified3dViewer) {
        unified3dViewer.classList.add('active');
        
        // Check if Plattar is already loaded
        const isPlattarLoaded = unified3dViewer.classList.contains('plattar-loaded');
        
        if (!isPlattarLoaded) {
          console.log('Loading Plattar 3D model for the first time...');
          loadPlattarOnDemand();
        } else {
          console.log('Plattar already loaded, just showing...');
          // Trigger a resize to ensure proper display
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
            fixShopifyBlockWidth();
          }, 100);
        }
      }
    }

    // Function to load Plattar on demand
    function loadPlattarOnDemand() {
      const embedContainer = document.getElementById('plattar-embed-container');
      const storageContainer = document.getElementById('plattar-blocks-storage');
      
      if (!embedContainer || !storageContainer) {
        console.error('Plattar containers not found');
        return;
      }
      
      console.log('Moving Plattar blocks to active container...');
      
      // Clear the loading placeholder
      embedContainer.innerHTML = '';
      
      // Move all Plattar blocks from storage to active container
      while (storageContainer.firstChild) {
        embedContainer.appendChild(storageContainer.firstChild);
      }
      
      // Mark as loaded
      unified3dViewer.classList.add('plattar-loaded');
      
      // Wait for Plattar to initialize properly
      waitForPlattarInitialization();
    }

    // Function to wait for Plattar to properly initialize
    function waitForPlattarInitialization() {
      console.log('Waiting for Plattar to initialize...');
      
      let attempts = 0;
      const maxAttempts = 30; // 3 seconds
      
      const checkInitialization = () => {
        attempts++;
        
        const plattarViewer = unified3dViewer.querySelector('plattar-viewer');
        const plattarIframe = unified3dViewer.querySelector('plattar-viewer iframe');
        
        if (plattarIframe && plattarIframe.src) {
          console.log('✅ Plattar iframe found and has src, initializing...');
          
          // Ensure proper dimensions
          setTimeout(() => {
            fixShopifyBlockWidth();
            window.dispatchEvent(new Event('resize'));
          }, 100);
          
          setTimeout(() => {
            fixShopifyBlockWidth();
            window.dispatchEvent(new Event('resize'));
          }, 500);
          
          setTimeout(() => {
            fixShopifyBlockWidth();
            window.dispatchEvent(new Event('resize'));
            removeLoadingOverlays();
          }, 1000);
          
          return;
        }
        
        if (attempts >= maxAttempts) {
          console.warn('Plattar initialization timeout, but continuing...');
          setTimeout(() => {
            fixShopifyBlockWidth();
            window.dispatchEvent(new Event('resize'));
          }, 100);
          return;
        }
        
        console.log(`Waiting for Plattar... attempt ${attempts}/${maxAttempts}`);
        setTimeout(checkInitialization, 100);
      };
      
      checkInitialization();
    }
    
    // Toggle between views
    view3dBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('View 3D button clicked, current view:', currentView);
      
      if (currentView === 'gallery') {
        show3D();
      } else {
        showGallery();
      }
    });
    
    // Don't touch the View at Home button - let Plattar handle it
    if (viewAtHomeBtn) {
      console.log('View at Home button found, letting Plattar handle it');
    }
  }
  
  // Wait for DOM and Plattar to be ready
  function waitForDependencies() {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(initUnified3DGallery, 100);
      // Try again after a longer delay in case elements load later
      setTimeout(initUnified3DGallery, 1000);
      // Final attempt after Plattar should be loaded
      setTimeout(initUnified3DGallery, 2000);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initUnified3DGallery, 100);
        setTimeout(initUnified3DGallery, 1000);
        setTimeout(initUnified3DGallery, 2000);
      });
    }
  }

  // Function to wait for Plattar to be available
  function waitForPlattar(callback, attempts = 0) {
    const maxAttempts = 50; // 5 seconds total
    
    if (window.Plattar || attempts >= maxAttempts) {
      console.log('Plattar available or max attempts reached');
      callback();
      return;
    }
    
    console.log(`Waiting for Plattar... attempt ${attempts + 1}`);
    setTimeout(() => waitForPlattar(callback, attempts + 1), 100);
  }
  
  // Also try to initialize when page loads
  window.addEventListener('load', function() {
    setTimeout(initUnified3DGallery, 500);
  });
  
  waitForDependencies();

  // Function to update arrow visibility based on current slide
  function updateArrowVisibility() {
    if (!window.productGlide) return;
    
    const prevArrow = document.querySelector('.slider-nav-arrow.prev');
    const nextArrow = document.querySelector('.slider-nav-arrow.next');
    
    if (!prevArrow || !nextArrow) return;
    
    const currentIndex = window.productGlide.index;
    const totalSlides = window.productGlide.settings.length || 0;
    
    console.log(`Slide ${currentIndex + 1} of ${totalSlides}`);
    
    // Hide previous arrow on first slide
    if (currentIndex === 0) {
      prevArrow.classList.add('hidden');
    } else {
      prevArrow.classList.remove('hidden');
    }
    
    // Hide next arrow on last slide
    if (currentIndex === totalSlides - 1) {
      nextArrow.classList.add('hidden');
    } else {
      nextArrow.classList.remove('hidden');
    }
  }

  // Initialize arrow visibility when Glide is ready
  function initializeArrowVisibility() {
    // Wait for Glide to be initialized
    const checkGlide = () => {
      if (window.productGlide) {
        console.log('Glide found, setting up arrow visibility');
        
        // Initial arrow state
        updateArrowVisibility();
        
        // Listen for slide changes
        window.productGlide.on('move', updateArrowVisibility);
        window.productGlide.on('mount.after', updateArrowVisibility);
        
        return;
      }
      
      // Check again after 100ms
      setTimeout(checkGlide, 100);
    };
    
    checkGlide();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(initializeArrowVisibility, 200);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initializeArrowVisibility, 200);
    });
  }

  // Handle menu interactions to prevent conflicts
  function handleMenuStateChange() {
    const galleryWrapper = document.querySelector('.mobile-gallery-wrapper');
    const body = document.body;
    
    // Check if any menu is open
    const isMenuOpen = body.classList.contains('menu-open') || 
                       body.classList.contains('menu-drawer-open') || 
                       body.classList.contains('overflow-hidden') ||
                       document.querySelector('.submenu-open');
    
    if (galleryWrapper) {
      if (isMenuOpen) {
        galleryWrapper.style.pointerEvents = 'none';
        console.log('Menu open - gallery interactions disabled');
      } else {
        galleryWrapper.style.pointerEvents = 'auto';
        console.log('Menu closed - gallery interactions enabled');
      }
    }
  }

  // Monitor for menu state changes
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        handleMenuStateChange();
      }
    });
  });

  // Observe body class changes
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Also observe for submenu changes
  document.addEventListener('click', function() {
    setTimeout(handleMenuStateChange, 100);
  });
  
  // Re-initialize on window resize (but no need to check mobile/desktop boundary)
  let resizeTimeout;
  
  window.addEventListener('resize', function() {
    // Clear previous timeout
    clearTimeout(resizeTimeout);
    
    // If 3D is active, fix dimensions after resize
    if (currentView === '3d') {
      resizeTimeout = setTimeout(() => {
        fixShopifyBlockWidth();
        removeLoadingOverlays();
      }, 250);
    }
  });
  
  // Also listen for orientation changes
  window.addEventListener('orientationchange', function() {
    if (currentView === '3d') {
      setTimeout(() => {
        fixShopifyBlockWidth();
        removeLoadingOverlays();
      }, 500);
    }
  });
  
})();